module.exports = __webpack_public_path__ + "img/skyward-atlas.d0d4b758.webp";